import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import React from 'react';

type Props = {
    children: any;
    className?: string;
};

export const InvoiceSummaryList = ({ children, className }: Props) => {
    return <div className={cn('flex flex-col', className)}>{children}</div>;
};
